import * as React from 'react';
import b_ from 'b_';

import './index.scss';

interface Props {
  icon: string;
  title: string;
}

const b = b_.with('stock-landing-benefits-subitem');

export const SubItem: React.FC<Props> = ({ icon, title, children }) => (
  <div className="invest-landing-subitem">
    <div className="invest-landing-subitem__wrapper">
      <div className="invest-landing-subitem__image-wrapper">
        <img className={b('icon')} src={icon} alt="" />
      </div>
      <div>
        <h3 className="invest-landing-subitem__title">{title}</h3>
        <p className="invest-landing-subitem__text">{children}</p>
      </div>
    </div>
  </div>
);
